import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageEmptyStateComponent } from './page-empty-state.component';



@NgModule({
  declarations: [
    PageEmptyStateComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PageEmptyStateComponent
  ]
})
export class PageEmptyStateModule { }
